import { DialogProps } from "@mui/material";
import { ReactNode } from "react";
import ResponsiveDialog from "components/form-components/responsive-dialog";
import ModalTopBar from "components/form-components/modal-top-bar";

interface Props {
  open: boolean;
  children: ReactNode | null;
  handleClose: () => void;
  title: ReactNode | string;
  headerChildren?: ReactNode;
  dialogProps?: Omit<DialogProps, "open" | "onClose">;
  customCloseButton?: ReactNode;
}

const FormModal = ({ open, title, children, handleClose, headerChildren, dialogProps, customCloseButton }: Props) => {
  return (
    <ResponsiveDialog open={open} onClose={handleClose} {...dialogProps}>
      <ModalTopBar title={title} headerChildren={headerChildren} handleClose={handleClose} customCloseButton={customCloseButton} />
      {children}
    </ResponsiveDialog>
  );
};

export default FormModal;
